define([
    'edge/platform/base/BaseCtrl'
], (BaseCtrl)=> {
    const fn = ($scope, $anchorScroll, submissionViewModel)=> {
    const ctrl = Object.create(BaseCtrl);
    const submissionVM = submissionViewModel();

ctrl.init = ()=> {
    $anchorScroll();
    /* Rating object */
    $scope.view = submissionVM.draftData.lobs.homeowners.rating;
    $scope.view.value = $scope.view.value || {};



    /* Additional fields */
    //$scope.isAdditionalOpen = isAnyAdditionalField();
};

ctrl.next = (nextFn)=> {

    $scope.view.deadboltsNumber.value = $scope.view.deadbolts.value ? 1 : undefined;

    //Sending default values for the fields to overcome PC validations
    $scope.view.visibleToNeighbors.value = true;
    //ENHC0011872 NC & SC Property Underwriting Updates
    //$scope.view.swimmingPoolFencing.value = false;
    if($scope.view.swimmingPoolExists.value== true){
        $scope.view.swimmingPoolFencing.value = true;
    }else{
        $scope.view.swimmingPoolFencing.value = false;
    }
    $scope.view.swimmingPoolDivingBoard.value = false;
    $scope.view.trampolineSafetyNet.value = false;
    $scope.view.smokeAlarmOnAllFloors.value = true;
    // Temp Fix - This question should be "true" always to generate the quote - 16/09/2016
    //$scope.view.smokeAlarm.value = true;

    nextFn(submissionVM);
};

return ctrl.create($scope);
};
fn.$inject = ['$scope', '$anchorScroll', 'submissionViewModel'];

return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/controllers/HORatingCtrl.js
 **/